import { Tooltip } from '@assembly-js/design-system';
import clsx from 'clsx';
import React, { CSSProperties } from 'react';

interface BaseStatusIndicatorProps {
  title: React.ElementType | React.ReactFragment | string;
  customSpacings?: CSSProperties;
  isSuccess?: boolean;
  hasTooltip?: boolean;
}

export const BaseStatusIndicator = (props: BaseStatusIndicatorProps) => {
  const { hasTooltip = true, title, isSuccess = false, customSpacings } = props;

  return (
    <Tooltip disabled={!hasTooltip} content={title}>
      <div className="flex items-center justify-center">
        <div
          className={clsx(
            'absolute h-2 w-2 rounded-full z-[1500]',
            isSuccess ? 'bg-medium-dark-green' : 'bg-[#FFA500]',
          )}
          style={{ ...customSpacings }}
        />
      </div>
    </Tooltip>
  );
};
